@switch (type) {
  @case ('bauhaus') {
    <lib-avatar-bauhaus [colors]="colors" [name]="name" [inputSize]="inputSize" />
  }
  @case ('beam') {
    <lib-avatar-beam [colors]="colors" [name]="name" [inputSize]="inputSize" />
  }
  @case ('marble') {
    <lib-avatar-marble [colors]="colors" [name]="name" [inputSize]="inputSize" />
  }
  @case ('pixel') {
    <lib-avatar-pixel [colors]="colors" [name]="name" [inputSize]="inputSize" />
  }
  @case ('ring') {
    <lib-avatar-ring [colors]="colors" [name]="name" [inputSize]="inputSize" />
  }
  @case ('sunset') {
    <lib-avatar-sunset [colors]="colors" [name]="name" [inputSize]="inputSize" />
  }
}
